// src/utils/buildInfo.js
// Utility to fetch and display build information

export const getBuildInfo = async () => {
  try {
    const response = await fetch("/build-info.json");
    if (response.ok) {
      return await response.json();
    }
  } catch (error) {
    console.warn("Build info not available:", error);
  }

  // Fallback to environment variables
  return {
    environment: process.env.NODE_ENV || "unknown",
    dockerfile: "unknown",
    build_time: "unknown",
    api_url: process.env.REACT_APP_API_URL || "unknown",
  };
};

// Function to log build info to console
export const logBuildInfo = async () => {
  const buildInfo = await getBuildInfo();
  console.group("🏗️ Build Information");
  console.log("Environment:", buildInfo.environment);
  console.log("Dockerfile:", buildInfo.dockerfile);
  console.log("Build Time:", buildInfo.build_time);
  console.log("API URL:", buildInfo.api_url);
  console.log("NODE_ENV (React):", process.env.NODE_ENV);
  console.log(
    "BUILD_ENV (Dockerfile):",
    process.env.REACT_APP_BUILD_ENV || buildInfo.node_env || "unknown"
  );
  console.log(
    "DOCKERFILE:",
    process.env.REACT_APP_DOCKERFILE || buildInfo.dockerfile || "unknown"
  );
  console.groupEnd();
  return buildInfo;
};
